import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.regular-saaspass-app-users', {
        url: '/regular-saaspass-app-users',
        component: 'companyUserDirectoriesSaaspassUsersRegularSaaspassAppUsers',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/regular-saaspass-app-users/regular-saaspass-app-users.state.js